export default __webpack_public_path__ + "static/media/dashboard_home.36082e81.png";